import { render, staticRenderFns } from "./appointmentDetail.vue?vue&type=template&id=6f382679&scoped=true"
import script from "./appointmentDetail.vue?vue&type=script&lang=js"
export * from "./appointmentDetail.vue?vue&type=script&lang=js"
import style0 from "./appointmentDetail.vue?vue&type=style&index=0&id=6f382679&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f382679",
  null
  
)

export default component.exports